import React, { useEffect, useMemo } from 'react';
import cl from 'classnames';
import { PopUpNotification } from 'src/interface';
import { useLanguage, usePopUpNotifications } from 'src/hooks';
import errorIcon from 'src/icons/errorNtfc.svg';
import successIcon from 'src/icons/successNtfc.svg';
import styles from './popUpNotificationsStyle.module.scss';

export const PopUpNotifications: React.FC<{
  filter?: (notification: PopUpNotification) => void;
}> = ({ filter }) => {
  const { notifications, clearTimeout, removeNotification } =
    usePopUpNotifications();
  const { td } = useLanguage();

  useEffect(() => {
    notifications.forEach(({ uuid, timeout }) => {
      if (timeout) {
        clearTimeout(uuid);

        setTimeout(() => {
          removeNotification(uuid);
        }, timeout);
      }
    });
  }, [notifications, clearTimeout, removeNotification]);

  const getIconUrl = (type: PopUpNotification['type']): string => {
    switch (type) {
      case 'success':
        return successIcon;
      case 'error':
        return errorIcon;
    }
  };

  const filteredItems = useMemo(
    () => (filter ? notifications.filter(filter) : notifications),
    [notifications, filter],
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {filteredItems.map(({ title, uuid, type }) => (
          <div
            key={`pupUpNot${uuid}`}
            className={cl(
              styles.notification,
              type === 'success' && styles.success,
              type === 'error' && styles.error,
            )}
            onClick={() => {
              removeNotification(uuid);
            }}
          >
            <img src={getIconUrl(type)} alt="" className={styles.svg} />
            <div className={styles.title}>{td(title)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopUpNotifications;
